import React, {createContext, FunctionComponent, useState} from "react";

type ContextProps = {
    setEmbedURL: (_:string|null) => void
    embedURL: string|null
    setWidth: (_:number) => void
    width: number
    setLeft: (_:number) => void
    left: number|null
    setTop: (_:number) => void
    top: number|null
    setRefreshPosition: (_:boolean) => void
    refreshPosition: boolean
}

export const HostBubbleContext = createContext<ContextProps>({} as ContextProps);

let HostBubbleContextProvider: FunctionComponent = ({children}) => {

    const [embedURL, setEmbedURL] = useState<string|null>(null);
    const [width, setWidth] = useState<number>(0);
    const [left, setLeft] = useState<number|null>(null);
    const [top, setTop] = useState<number|null>(null);
    const [refreshPosition, setRefreshPosition] = useState<boolean>(false);

    return <HostBubbleContext.Provider value={{
        setEmbedURL,
        embedURL,
        setWidth,
        width,
        setLeft,
        left,
        setTop,
        top,
        setRefreshPosition,
        refreshPosition}}>
        {children}
    </HostBubbleContext.Provider>;
};

const HostBubbleContextConsumer = HostBubbleContext.Consumer;

export default HostBubbleContextProvider;
export {HostBubbleContextConsumer};